import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Login from "./Login";
import BootSplash from "./BootSplash";
import { ensureAccessToken } from "./api";
import { clearAccessToken } from "./token";
import { getCurrentUser } from "modules/current_user/actions";

/**
 * Boots JWT (refresh cookie → access in memory), then loads current_user.
 * Unauthenticated users see Login.
 */
const AuthGate = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const current_user = useSelector((state) => state.current_user);
  const isLoginRoute = location.pathname === "/login";
  const returnToRef = useRef(isLoginRoute ? "/" : `${location.pathname}${location.search}`);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      const token = await ensureAccessToken();
      if (cancelled) return;

      if (!token) {
        setAuthed(false);
        setReady(true);
        if (!isLoginRoute) history.replace("/login");
        return;
      }

      setAuthed(true);
      try {
        await dispatch(getCurrentUser());
      } catch (_e) {
        clearAccessToken();
        setAuthed(false);
        history.replace("/login");
      }
      if (!cancelled) setReady(true);
    };

    bootstrap();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLoginSuccess = async () => {
    setAuthed(true);
    await dispatch(getCurrentUser());
    setReady(true);
    history.replace(returnToRef.current || "/");
  };

  if (!ready) {
    return <BootSplash />;
  }

  if (!authed || isLoginRoute) {
    if (authed && isLoginRoute) {
      history.replace("/");
      return null;
    }
    return <Login onSuccess={onLoginSuccess} />;
  }

  if (_.isEmpty(current_user)) {
    return <BootSplash />;
  }

  return children;
};

export default AuthGate;
